import { Menu } from 'antd';
import Icon, { LogoutOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { ReactComponent as openInNew } from 'assets/svgs/openInNew.svg';
import {
  IUserMenuItem,
  useUserMenuItems,
} from 'components/UI/UserMenu/useUserMenuItems';

const renderItem = ({ key, label, external, onClick }: IUserMenuItem) => (
  <Menu.Item key={key} onClick={onClick}>
    {label}
    {key === 'register-order-intention' && ' +'}
    {external && (
      <Icon component={openInNew} aria-hidden style={{ marginLeft: 8 }} />
    )}
  </Menu.Item>
);

function UserMenuOverlay() {
  const { t } = useTranslation('translation', { keyPrefix: 'header' });
  const { ordersItems, supportItems, logout } = useUserMenuItems();

  return (
    <>
      {ordersItems.map(renderItem)}
      <Menu.Divider />
      {supportItems.map(renderItem)}
      <Menu.Item onClick={logout} key="logout">
        {t('logout')} <LogoutOutlined />
      </Menu.Item>
    </>
  );
}

export default UserMenuOverlay;
